import useOnMount from '@/hooks/useOnMount';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import QuizletSellScreen from './components/sell/quizlet-sell-screen';
import { useQuizletControllerGetLatestResults } from '@/api/generated/quizlet/quizlet';
import useVisitorSession from '@/hooks/useVisitorSession';

export default function QuizletSellPage() {
  const setIntercomIsVisible = useSetIntercomIsVisible();
  const { sessionToken } = useVisitorSession();
  const { data: quizletResults } = useQuizletControllerGetLatestResults({
    query: { enabled: !!sessionToken },
  });

  // Hide intercom when the component mounts
  useOnMount(() => {
    setIntercomIsVisible.mutate(false);
    return () => {
      setIntercomIsVisible.mutate(true);
    };
  });

  // Always render the sell screen, even if quizletResults is undefined
  // The PersonalizedList component will handle displaying generic marketing messages if needed
  return <QuizletSellScreen results={quizletResults} />;
}
